module.exports = __webpack_public_path__ + "img/caption.fa7594e9.png";